import { Context } from "@nuxt/types/app";
import { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";

import { Pagination } from "@/shared/models/table.model";

export function employeeBenefitPlugin({ store }: Context) {
  function getAuthHeaders(): AxiosRequestConfig {
    const token = store.getters["auth/getUserToken"];

    const cookieToken = Cookies.get("t");

    return {
      headers: {
        authorization: `Bearer ${cookieToken ? cookieToken : token}`,
      },
    };
  }

  function showErrorSnackbar(message?: string): void {
    store.dispatch("app/toggleSnackBar", {
      message: message || "Something wrong.",
      color: "invert-error",
    });
  }

  function showSuccessSnackbar(message?: string): void {
    store.dispatch("app/toggleSnackBar", {
      message: message || "Success",
      color: "invert-success",
    });
  }

  function getOneLineParams<T>(params: T): string {
    const oneLineParams = Object.entries(params)
      .map(([key, value]: [string, string]): string | undefined => {
        if (value) return `${key}=${encodeURIComponent(value)}`;
      })
      .filter((param) => !!param)
      .join("&");

    return oneLineParams;
  }

  function isPaginationChanged(
    current: Pagination,
    previous: Pagination,
  ): boolean {
    const hasPerPageChanged = previous.itemsPerPage !== current.itemsPerPage;
    const hasPageChanged = previous.page !== current.page;

    return hasPerPageChanged || hasPageChanged;
  }

  return {
    getAuthHeaders,
    getOneLineParams,
    isPaginationChanged,
    showErrorSnackbar,
    showSuccessSnackbar,
  };
}
